import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { motion } from 'framer-motion';

const WhatsAppFloat = () => {
  // 👇 अपना WhatsApp नंबर यहाँ डालें (देश कोड के साथ, बिना + या 0 के)
  // उदाहरण: 91 97557 94514
  const phoneNumber = '91 97557 94514';
  
  // 👇 यूज़र जब क्लिक करे तो जो मैसेज ऑटोमैटिक टाइप होकर आए
  const message = encodeURIComponent(
    'Hello! I am interested in DevDeepam Solar products. Please share more details.'
  );

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-[9999] flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] hover:shadow-[0_12px_40px_rgba(37,211,102,0.6)] transition-shadow duration-300 group"
    >
      {/* Pulse Ring Animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 group-hover:opacity-40"></span>
      
      {/* WhatsApp Icon */}
      <FaWhatsapp className="w-7 h-7 sm:w-8 sm:h-8 relative z-10" />
      
      {/* Tooltip (Desktop only) */}
      <span className="absolute right-full mr-3 px-3 py-1.5 bg-[#0D3F7F] text-white text-[11px] font-bold rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden sm:block shadow-lg">
        Chat with us
        <span className="absolute top-1/2 -right-1 w-2 h-2 bg-[#0D3F7F] rotate-45 -translate-y-1/2"></span>
      </span>
    </motion.a>
  );
};

export default WhatsAppFloat;